
import { SaveButton } from './save-cart-button';
import { EditButton } from './edit-cart-button';
import { DeleteButton } from './delete-cart-button';
import { LoadButton } from './load-cart-button';
import { ShareCartLink } from './share-cart-link';

/**
 * Initialise.
 *
 * @return {void}
 */
function init() {
	const saveButtonElements = document.querySelectorAll( '.js-qala-ssc-save-cart' );
	const editButtonElements = document.querySelectorAll( '.js-qala-ssc-edit-cart-button' );
	const loadButtonElements = document.querySelectorAll( '.js-qala-ssc-load-cart-button' );
	const deleteButtonElements = document.querySelectorAll( '.js-qala-ssc-delete-cart-button' );

	if ( saveButtonElements.length ) {
		saveButtonElements.forEach( buttonElement => {
			const saveButton = new SaveButton( buttonElement );
			saveButton.init();
		} );
	}

	if ( editButtonElements.length ) {
		editButtonElements.forEach( buttonElement => {
			const editButton = new EditButton( buttonElement );
			editButton.init();
		} );
	}

	if ( loadButtonElements.length ) {
		loadButtonElements.forEach( buttonElement => {
			const loadButton = new LoadButton( buttonElement );
			loadButton.init();
		} );
	}

	if ( deleteButtonElements.length ) {
		deleteButtonElements.forEach( buttonElement => {
			const deleteButton = new DeleteButton( buttonElement );
			deleteButton.init();
		} );
	}

	// Initialize share cart links
	ShareCartLink.init();
}

/**
 * Workaround for failing event listeners on iOS. Confirmed working on physical iPhone 13. 05-2024.
 *
 * @see https://developer.apple.com/forums/thread/651215
 */
if ( document.readyState !== 'loading' ) {
	setTimeout( init, 1000 );
} else {
	document.addEventListener( 'DOMContentLoaded', function() {
		setTimeout( init, 1000 );
	} );
}
